import { useEffect, useState } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;
let cache = null;

export const fetchAppLinks = (force = false) => {
  if (!cache || force) {
    cache = axios.get(`${API}/api/marketing/app-links`).then(r => r.data).catch(() => { cache = null; return null; });
  }
  return cache;
};

export default function useAppLinks() {
  const [links, setLinks] = useState(null);
  useEffect(() => {
    let alive = true;
    fetchAppLinks().then(d => alive && setLinks(d));
    return () => { alive = false; };
  }, []);
  return links;
}
